module.exports = {"410703001":"胜利路街道","410703002":"解放路街道","410703003":"中同街街道","410703004":"健康路街道","410703007":"自由路街道","410703008":"南桥街道","410703009":"铁西街道","410703100":"平原镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410703.json
// module id = 1704
// module chunks = 0